import _ from 'lodash';
import Immutable from 'immutable';

import { checkAccessOnObject } from '../utils/rights';
import PRIVILEGE_CODES from '../configs/privilegeCodes';
import RESOURCE_TYPES from '../configs/resourceTypes';
import { resolveViewType, VIEW_TYPES } from '../utils/viewType';

import appState from '../appState';
import { VIEW_MODES } from '../configs/viewSettings';

export default {
  create(data = {}) {
    const view = {};
    view.__name = 'View';

    view.uuid = Math.random();
    view.id = data.id != null ? String(data.id) : null;

    if (data.index !== undefined) {
      view.index = data.index;
    }

    // get privilege
    const catalog = appState.get('catalogs').get(data.catalogId);
    view.isAdmin =
      catalog &&
      checkAccessOnObject(
        RESOURCE_TYPES.CATALOG,
        { privilegeCode: catalog.get('privilegeCode') },
        PRIVILEGE_CODES.ACCESS,
      );

    // name
    view.name = data.name;
    view.originName = data.originName || data.name;
    view.type = resolveViewType(data);
    view.forRights = view.type === VIEW_TYPES.SHARED;
    // Чужие (forRights=true + privilegeCode='admin') — показываем originName || name
    // Мои (все остальные) — показываем name || originName
    const isForeign = view.forRights && data.privilegeCode === PRIVILEGE_CODES.ADMIN;
    view.displayName = isForeign ? view.originName || view.name : view.name || view.originName;

    // other props
    view.isOwner = data.isOwner || false;
    view.privilegeCode = data.privilegeCode;
    view.fieldPrivilegeCodes = data.fieldPrivilegeCodes || {};
    view.c = data.privilegeCode;

    view.catalogId = data.catalogId;
    view.viewMode = data.viewMode || VIEW_MODES.TABLE;

    if (_.isEmpty(data)) {
      view.isNew = true;
    }

    // filters
    view.filters = data.filters || {};
    view.filtersChanged = data.filtersChanged || false;

    return Immutable.fromJS(view);
  },
};
